import { PROBE_ERROR_MESSAGES } from '../../../../util/error.util'
import { getGwsDirectoryUserId } from '../../../../util/employeeLicenses.util'
import { HUB_INTEGRATIONS, TASK_ACTIONS, TASK_TYPES } from '../../../../util/hub-task-management/hub.constants'
import { DEFAULT_GWS_HUB_POLL } from '../../engage/integrations/gws/hubTasks'
import {
  formatHubTaskStatusMessage,
  isHubTaskFailed,
  parseHubTaskErrors,
  submitEngageHubTask,
} from '../../engage/utils/submitEngageHubTask'

const trimEmail = (value) => (typeof value === 'string' ? value.trim() : '')

const actionFailedMessage = (intl) => intl.formatMessage({ id: 'GENERAL.ACTION_FAILED' })

/**
 * Changes the Google Workspace primary email before Augmentt stores it.
 * A failed Directory update leaves the employee row unchanged.
 */
export const submitGwsPrimaryEmailChange = async ({ employee, nextEmail, selectedCustomer, userId, intl } = {}) => {
  const primaryEmail = trimEmail(nextEmail)
  const currentEmail = trimEmail(employee?.email)

  if (!primaryEmail || primaryEmail === currentEmail) {
    return
  }

  if (!selectedCustomer?.id) {
    throw new Error(actionFailedMessage(intl))
  }

  const directoryUserId = getGwsDirectoryUserId(employee)
  if (!directoryUserId && !currentEmail) {
    throw new Error(actionFailedMessage(intl))
  }

  const task = await submitEngageHubTask({
    actions: {
      employeeEmail: currentEmail,
      ...(directoryUserId ? { employeeIdentifier: directoryUserId } : {}),
      primaryEmail,
    },
    tasktype: TASK_TYPES.gwsUser,
    action: TASK_ACTIONS.update,
    integration: HUB_INTEGRATIONS.google,
    customerId: selectedCustomer.id,
    organizationId: selectedCustomer.organization,
    userId,
    poll: DEFAULT_GWS_HUB_POLL,
  })

  if (!isHubTaskFailed(task)) {
    return
  }

  const message = formatHubTaskStatusMessage({
    errors: parseHubTaskErrors(task?.errors),
    errorMappings: PROBE_ERROR_MESSAGES,
    intl,
  })

  throw new Error(message || actionFailedMessage(intl))
}
